import React from "react";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";

import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";

import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { Close } from "@material-ui/icons";


const styles = (theme: Theme) =>
  createStyles({
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

interface DialogTitleProps extends WithStyles<typeof styles> {
  id?: string;
  children: React.ReactNode;
  onClose: ((input?: any) => void) | false;
}

export const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;

  const title = typeof children === "string" ? <Typography variant="h6" style={onClose ? { paddingRight: "2em" } : {}}>{children}</Typography> : children;
  return (
    <MuiDialogTitle disableTypography {...other}>
      {title}
      {onClose && (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
});

export const DialogContent = MuiDialogContent;

export const DialogActions = MuiDialogActions;
